import { Component, OnInit, computed, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { Auth } from './core/auth/auth';
import { LibService } from './core/services/lib.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, ButtonModule, MenubarModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements OnInit {
  private readonly auth = inject(Auth);
  private readonly lib = inject(LibService);

  readonly items = computed<MenuItem[]>(() => this.buildMenu(this.auth.isLoggedIn()));

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      this.lib.logx().catch((error) => {
        console.error('Failed to initialize fingerprint logging:', error);
      });
    }
  }

  private buildMenu(isLoggedIn: boolean): MenuItem[] {
    const items: MenuItem[] = [{ label: 'Ad Search', routerLink: '/' }];

    if (!isLoggedIn) {
      items.push(
        { label: 'Login', routerLink: '/login' },
        { label: 'Subscribe', routerLink: '/subscribe' },
      );
      return items;
    }

    items.push(
      { label: 'Examples', routerLink: '/examples' },
      { label: 'Help Centre', routerLink: '/helpdesk' },
      {
        label: 'My Account',
        items: [
          { label: 'Info', routerLink: '/account/info', icon: 'pi pi-user' },
          { label: 'Subscription', routerLink: '/account/subscription', icon: 'pi pi-credit-card' },
          { label: 'Security', routerLink: '/account/security', icon: 'pi pi-lock' },
          { label: 'Affiliate', routerLink: '/account/affiliate', icon: 'pi pi-users' },
          { separator: true },
          { label: 'Logout', icon: 'pi pi-sign-out', command: () => this.auth.logout() },
        ],
      },
    );

    return items;
  }
}
